<div class="add-user-dialog-content">
  <span class="add-user-dialog-header">
    <h2 mat-dialog-title>Add User</h2>
    <button mat-icon-button type="button" matTooltip="Cancel Adding User" class="inverse-button-no-border"
      (click)="onCancelingAddUser()">
      <mat-icon>close</mat-icon>
    </button>
  </span>
  @if (activeDirectoryUserList.length == 0 && !userAlreadyExist && !userHasBeenSelected && !loading) {
    <form>
      <mat-form-field appearance="outline">
        <mat-label>Name | EmployeeID | Email</mat-label>
        <input matInput type="text" [formControl]="userSearchFormControl">
        @if (userSearchFormControl.hasError('required')) {
          <mat-error>
            Field is required.
          </mat-error>
        }
      </mat-form-field>
      <button id="employee-search-btn" mat-button type="submit" matTooltip="Search for employee" class="regular-button"
        [ngClass]="{'regular-button-disabled' : userSearchFormControl.hasError('required')}"
        [disabled]="userSearchFormControl.hasError('required')" (click)="onUserSearch()">
        <mat-icon>search</mat-icon>
      </button>
    </form>
  }


  <!-- User select -->
  @if (activeDirectoryUserList.length > 0 && !userAlreadyExist && !userHasBeenSelected && !loading) {
    <button mat-button class="add-user-back-to-search-button" (click)="onNewUserSearch()">
      <mat-icon>arrow_back</mat-icon>
      Search new user
    </button>
    <mat-list>
      @for (user of activeDirectoryUserList; track user) {
        <mat-list-item (click)="onUserSelect(user)">
          <mat-icon matListIcon>add</mat-icon>
          <span matLine>
            {{user.DisplayName}} - {{user.LoginName}}
          </span>
        </mat-list-item>
      }
    </mat-list>
  }

  <!-- User Add - user exist -->
  @if (userAlreadyExist && !loading) {
    <button mat-button class="add-user-back-to-search-button" (click)="onBackToUserList()">
      <mat-icon>arrow_back</mat-icon>
      Back to user list
    </button>
    <div class="add-user-dialog-user-exist">
      <p><strong><i>{{selectedUser.DisplayName}} - {{selectedUser.LoginName}}</i> is already exist in AVN Directory
    </strong> </p>
    <button mat-button class="regular-button" (click)="onNewUserSearch()">
      <mat-icon>person_add</mat-icon>
      Add another user
    </button>
    <button mat-button class="regular-button" (click)="onNavigateToUserProfile()">
      <mat-icon>person</mat-icon>
      Go to user profile
    </button>
  </div>
}

<!-- User Add - user doest not exist  -->
@if (userHasBeenSelected && !userAlreadyExist && !loading) {
  <button mat-button class="add-user-back-to-search-button" (click)="onBackToUserList()">
    <mat-icon>arrow_back</mat-icon>
    Back to user list
  </button>
  <div class="add-user-dialog-new-user">
    <h2>Creating User Profile</h2>
    @if (!userAddedSuccessfully) {
      <p>Please fill in the required fields to create profile for
        <i>{{selectedUser.DisplayName}} - {{selectedUser.LoginName}}</i>.
      </p>
    }
    @if (userAddedSuccessfully) {
      <p>Successfully added user <i>{{selectedUser.DisplayName}} -
      {{selectedUser.LoginName}}</i>.</p>
    }
    @if (!userAddedSuccessfully) {
      <form [formGroup]="newUserInfoFormGroup">
        <mat-form-field appearance="outline">
          <mat-label>Job Title</mat-label>
          <input matInput formControlName="jobtitle" />
          @if (newUserInfoFormGroup.controls['jobtitle'].hasError('required')) {
            <mat-error>
              Field is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Division</mat-label>
          <mat-select (selectionChange)="onChangingDivision($event)" formControlName="divisionid">
            @for (division of userDivisions; track division) {
              <mat-option [value]="division.ID">
                {{division.Name}}
              </mat-option>
            }
          </mat-select>
          @if (newUserInfoFormGroup.controls['divisionid'].hasError('required')) {
            <mat-error>
              Field is required.
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Section</mat-label>
          <mat-select formControlName="sectionid">
            @for (section of userSections; track section) {
              <mat-option [value]="section.ID">
                {{section.Name}}
              </mat-option>
            }
          </mat-select>
          @if (newUserInfoFormGroup.controls['sectionid'].hasError('required')) {
            <mat-error>
              Field is required.
            </mat-error>
          }
        </mat-form-field>
        <span id="infoSpecialPermissionsInput">
          <label id="fieldNameLabel">Special Permissions</label>
          <br>
            <span class="permissions">
              <mat-slide-toggle formControlName="supervisor">Supervisor</mat-slide-toggle>
            </span>
            <span class="permissions">
              <mat-slide-toggle formControlName="admin">Site Administrator</mat-slide-toggle>
            </span>
          </span>
        </form>
      }
      <span>
        @if (!userAddedSuccessfully) {
          <button mat-button class="regular-button"
            [disabled]="!newUserInfoFormGroup.valid" [ngClass]="{'regular-button-disabled': !newUserInfoFormGroup.valid}"
            (click)="onAddingNewUser()">
            <mat-icon>check</mat-icon>
            Add user
          </button>
        }
        @if (userAddedSuccessfully) {
          <button mat-button class="regular-button" (click)="onNavigateToUserProfile()">
            <mat-icon>person</mat-icon>
            Go to user profile
          </button>
        }
        <button mat-button class="regular-button" (click)="onNewUserSearch()">
          <mat-icon>person_add</mat-icon>
          Add another user
        </button>
      </span>
    </div>
  }
  <div class="add-user-loading-container">
    @if (loading) {
      <mat-spinner color="accent"></mat-spinner>
    }
  </div>

</div>
